
export default function LocationSection() {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-6">
        <div className="max-w-6xl mx-auto">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-4xl font-bold text-stone-800 mb-6">
                1173 Budapest, Újlak utca 5.
              </h2>
              <div className="space-y-6 text-stone-700 leading-relaxed">
                <p className="text-lg">
                  <strong className="text-stone-800">Szépségszalon stúdió</strong> – nyugodt, szeparált helyiség.
                </p>
                <p className="text-lg">
                  Nem zsúfolt wellness, hanem egy nyugodt, saját tér, ahol Rád figyelek.
                </p>
                <div className="bg-amber-50 p-6 rounded-lg border-l-4 border-amber-500">
                  <h3 className="font-semibold text-stone-800 mb-2">
                    <i className="ri-map-pin-line mr-2 text-amber-700"></i>
                    Helyszín előnyei
                  </h3>
                  <ul className="space-y-2 text-stone-600">
                    <li>• Könnyen megközelíthető a XVII. kerületben</li>
                    <li>• Privát, nyugodt környezet</li>
                    <li>• Parkolási lehetőség</li>
                    <li>• Tiszta, higiénikus körülmények</li>
                  </ul>
                </div>
              </div>
            </div>
            
            <div className="relative">
              <img
                src="https://static.readdy.ai/image/5f12d79e9d850055a25ce719729b8deb/4cb85a8f34ce41c4ef0dc64e01588cb4.jpeg"
                alt="Masszázs helyiség"
                className="rounded-lg shadow-lg object-cover w-full h-96 object-top"
              />
              <div className="absolute -bottom-6 -left-6 bg-stone-800 text-white p-6 rounded-lg shadow-lg">
                <div className="text-center">
                  <div className="text-lg font-semibold">1173 Budapest</div>
                  <div className="text-sm opacity-90">Újlak utca 5.</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
